export const SELLER_QUOTES_SECTION_ID = 'seller-quotes';
